import { Icon, Input } from "@hcsc-fiber/react";
import { IInputProps } from "@hcsc-fiber/react/dist/types/Input/Input";
import React, { ChangeEvent, useContext, useState } from "react";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";
import styles from "./passwordInput.module.scss";

interface PasswordInputProp extends IInputProps {
  value: string;
  error: { message: string; code: string } | null;
  onChange: (_: ChangeEvent<{ value: string }>) => void;
}

const PasswordInput: React.FC<PasswordInputProp> = ({ value, onChange, error, ...restProps }) => {
  const [showPassword, setShowPassword] = useState(false);
  const language = useContext(StateContext).languageCode;

  const handleEyeCLick = () => {
    setShowPassword(prevVal => !prevVal);
  };

  return (
    <div>
      <label className={error ? styles.labelError : styles.label} data-testid="password-label">
        {translations.password[language]}
      </label>
      <div className={styles.buttonInputWrap}>
        <Input
          type={showPassword ? "text" : "password"}
          name="password"
          value={value}
          onChange={onChange}
          {...restProps}
        />
        <div onClick={handleEyeCLick} role="button" className={styles.inputBtn}>
          <Icon color="black" name={showPassword ? "eye-hide-line" : "eye-unhide-line"} size={3} />
        </div>
      </div>
    </div>
  );
};

export default PasswordInput;
